import { z } from 'zod';

/** Chat user attributes schema. */
export const chatUserAttributesSchema = z.object({
  first_name: z.string().nullish(),
  last_name: z.string().nullish(),
  id: z.number().or(z.string()),
});

/** Chat user attributes. */
export type ChatUserAttributes = z.infer<typeof chatUserAttributesSchema>;
